import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { PlanService } from 'src/app/core/services/plan.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { TIMEZONE_TO_COUNTRY } from 'src/app/shared/job-match-actions/send-assessment/timezone-country-map';

declare var bootbox: any;

interface TimezoneOption {
  name: string;
  offset: number;
  displayText: string;
  group: string;
}

// Native port of the legacy modifyPlan/modifyPlanModal pair
// (src/app/public/app/partials/missioncontrol/company/modifyPlan,
// modifyPlanModal). Both halves were live in the legacy code, not a
// dead/shadow pair: modifyPlanModal (modify-plan-modal.component.js) was the
// $uibModal wrapper opened by company-page.component.js's modifyPlan(isModify)
// (component: 'modifyPlanModal'), and it embedded modifyPlan
// (modify-plan.component.js, <modify-plan> element) as its body content -
// confirmed by modify-plan-modal.html:8-19 nesting <modify-plan> and by
// modifyPlan not being opened directly as a modal/state anywhere else in the
// app. A native BsModalService modal doesn't need that
// wrapper/content-component split, so both are merged into this one
// component.
//
// The legacy `timezone-selector` AngularJS directive (angular-timezone-
// selector-fixed) can't run inside a native component - same constraint
// documented on send-assessment.component.ts, which already replaced it with
// a native grouped list; this component reuses that same
// TIMEZONE_TO_COUNTRY-driven grouping (simplified to a plain grouped
// <select>, since this modal doesn't need ng-select's search behavior).
@Component({
  selector: 'app-company-page-modify-plan-modal',
  templateUrl: './company-page-modify-plan-modal.component.html',
  providers: [FourDotFiveDateFormatPipe]
})
export class CompanyPageModifyPlanModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  selectedPlanName: string;
  planTypeList: any[] = [];
  selectedPlan: any = {};
  futurePlan: any = {};
  isModifyPlan: boolean;
  isFuturePlanExists: boolean;
  isActivePlanExists: boolean;
  currentPlanEndDate: Date;

  isTrialPlan = false;
  isVendorPlan = false;
  browserTimeZone: string;

  groupedTimezones: { [key: string]: TimezoneOption[] } = {};

  callbackObject: any = { callbackType: 'cancel', entity: {} };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService,
    private planService: PlanService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private modalService: AngularModalService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.selectedPlanName = this.modalData.selectedPlanName;
    this.planTypeList = this.modalData.planTypeList;
    this.selectedPlan = this.modalData.selectedPlan;
    this.futurePlan = this.modalData.futurePlan;
    this.isModifyPlan = this.modalData.isModifyPlan;
    this.isFuturePlanExists = this.modalData.isFuturePlanExists;
    this.isActivePlanExists = this.modalData.isActivePlanExists;
    this.currentPlanEndDate = this.modalData.currentPlanEndDate;

    this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
    this.initializeTimezones();
    this.selectedPlan.planDetailDto.taAdded = 0;
    this.selectedPlan.planDetailDto.jbiAdded = 0;

    if (this.selectedPlanName && this.selectedPlanName.toLowerCase() === 'trial') {
      this.isTrialPlan = true;
    }
    if (this.selectedPlanName && this.selectedPlanName.toLowerCase() === 'vendor only') {
      this.isVendorPlan = true;
    }

    this.initializeStartAndEndDates();
  }

  initializeTimezones() {
    const timezoneChoices: TimezoneOption[] = (momentTimezone as any).tz.names().map(zone => {
      const zoneMoment = (momentTimezone as any).tz(zone);
      const offset = zoneMoment.utcOffset();
      const country = TIMEZONE_TO_COUNTRY[zone] || 'Other';
      return {
        name: zone,
        offset,
        displayText: `${zone.replace(/_/g, ' ')} (UTC${zoneMoment.format('Z')})`,
        group: `${country}:`
      };
    });
    timezoneChoices.sort((a, b) => a.offset - b.offset);
    this.groupedTimezones = {};
    timezoneChoices.forEach(zone => {
      if (!this.groupedTimezones[zone.group]) {
        this.groupedTimezones[zone.group] = [];
      }
      this.groupedTimezones[zone.group].push(zone);
    });
    if (!this.selectedPlan.planHeaderDto.timeZoneName) {
      this.selectedPlan.planHeaderDto.timeZoneName = this.browserTimeZone;
    }
  }

  initializeStartAndEndDates() {
    $(document).ready(() => {
      let datePickerStartDate = new Date();
      const startDateTimeStringInSelectedTimeZone = moment(this.selectedPlan.planHeaderDto.unformattedStartDate).tz(this.selectedPlan.planHeaderDto.timeZoneName).format('YYYY-MM-DDTHH:mm:ss.SSS');
      const endDateTimeStringInSelectedTimeZone = moment(this.selectedPlan.planHeaderDto.unformattedEndDate).tz(this.selectedPlan.planHeaderDto.timeZoneName).format('YYYY-MM-DDTHH:mm:ss.SSS');
      const startDateTime = new Date(startDateTimeStringInSelectedTimeZone);
      const endDateTime = new Date(endDateTimeStringInSelectedTimeZone);

      if (!this.isTrialPlan && this.isModifyPlan) {
        datePickerStartDate = moment(startDateTimeStringInSelectedTimeZone).add(-1, 'd').toDate();
      }

      ($('#effectiveStartDate') as any).datepicker({
        format: 'M d, yyyy',
        startDate: datePickerStartDate,
        weekStart: 1,
        autoclose: true
      });
      ($('#effectiveStartDate') as any).datepicker('setDate', startDateTime);
      ($('#effectiveStartDate') as any).datepicker('update', this.fourDotFiveDateFormatPipe.transform(startDateTime));

      ($('#effectiveEndDate') as any).datepicker({
        format: 'M d, yyyy',
        weekStart: 1,
        startDate: startDateTime,
        autoclose: true
      });
      ($('#effectiveEndDate') as any).datepicker('setDate', endDateTime);
      ($('#effectiveEndDate') as any).datepicker('update', this.fourDotFiveDateFormatPipe.transform(endDateTime));

      ($('#effectiveStartDate') as any).datepicker().on('changeDate', (e: any) => {
        this.selectedPlan.planHeaderDto.planStartDateDisplay = this.fourDotFiveDateFormatPipe.transform(e.date);
        this._validateStartAndEndDates();
      });
      ($('#effectiveEndDate') as any).datepicker().on('changeDate', (e: any) => {
        this.selectedPlan.planHeaderDto.planEndDateDisplay = this.fourDotFiveDateFormatPipe.transform(e.date);
        this._validateStartAndEndDates();
      });
    });
  }

  _validateStartAndEndDates() {
    const currentStartDateTime = new Date(this.selectedPlan.planHeaderDto.planStartDateDisplay);
    const currentEndDateTime = new Date(this.selectedPlan.planHeaderDto.planEndDateDisplay);
    if (currentStartDateTime >= currentEndDateTime) {
      let resetEndDate;
      if (this.selectedPlan.planHeaderDto.planType === 'Month to Month') {
        resetEndDate = moment(currentStartDateTime).add(1, 'M').endOf('day').toDate();
      } else {
        resetEndDate = moment(currentStartDateTime).add(6, 'M').endOf('day').toDate();
      }
      ($('#effectiveEndDate') as any).datepicker('setStartDate', moment(currentStartDateTime).endOf('day').toDate());
      ($('#effectiveEndDate') as any).datepicker('setDate', resetEndDate);
      ($('#effectiveEndDate') as any).datepicker('update', resetEndDate);
    } else {
      ($('#effectiveEndDate') as any).datepicker('setStartDate', moment(currentStartDateTime).endOf('day').toDate());
    }
  }

  onPlanTypeChange() {
    const currentDate = moment(this.selectedPlan.planHeaderDto.planStartDateDisplay).toDate();
    if (this.selectedPlan.planHeaderDto.planType === 'Month to Month') {
      this.selectedPlan.planHeaderDto.planEndDateDisplay = this.fourDotFiveDateFormatPipe.transform(moment(currentDate).add(1, 'M').toDate());
      this.selectedPlan.planHeaderDto.unformattedEndDate = moment(currentDate).add(1, 'M').toDate();
    } else {
      this.selectedPlan.planHeaderDto.planEndDateDisplay = this.fourDotFiveDateFormatPipe.transform(moment(currentDate).add(6, 'M').toDate());
      this.selectedPlan.planHeaderDto.unformattedEndDate = moment(currentDate).add(6, 'M').toDate();
    }
    this.selectedPlan.planHeaderDto.planEndDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.selectedPlan.planHeaderDto.unformattedEndDate));

    ($('#effectiveEndDate') as any).datepicker('setDate', this.selectedPlan.planHeaderDto.unformattedEndDate);
    ($('#effectiveEndDate') as any).datepicker('update', this.fourDotFiveDateFormatPipe.transform(this.selectedPlan.planHeaderDto.unformattedEndDate));
  }

  cancel() {
    this.callbackObject.callbackType = 'cancel';
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  savePlan() {
    let message = '';
    this.selectedPlan.planHeaderDto.unformattedEndDate = moment(this.selectedPlan.planHeaderDto.planEndDateDisplay).toDate();
    this.selectedPlan.planHeaderDto.planEndDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date(this.selectedPlan.planHeaderDto.unformattedEndDate)).endOf('day').toDate());
    this.selectedPlan.planHeaderDto.unformattedStartDate = moment(this.selectedPlan.planHeaderDto.planStartDateDisplay).toDate();
    this.selectedPlan.planHeaderDto.planStartDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.selectedPlan.planHeaderDto.unformattedStartDate).setHours(0, 0, 0, 0));
    if (this.isTrialPlan) {
      this.selectedPlan.planDetailDto.taAllocated = this.selectedPlan.planDetailDto.taAllocated + this.selectedPlan.planDetailDto.taAdded;
      this.selectedPlan.planDetailDto.jbiAllocated = this.selectedPlan.planDetailDto.jbiAllocated + this.selectedPlan.planDetailDto.jbiAdded;
    }

    if (this.isModifyPlan && (this.isFuturePlanExists && new Date(this.selectedPlan.planHeaderDto.planEndDateDisplay) >= new Date(this.futurePlan.planHeaderDto.planStartDateDisplay))) {
      message = "Next plan's start date will be modified based on the current plan's end date. Do you want to continue?";
      this._showWarningMessage(message);
    } else if (!this.isModifyPlan && this.isActivePlanExists && this.currentPlanEndDate >= new Date(this.selectedPlan.planHeaderDto.planStartDateDisplay)) {
      message = "Current plan's end date will be modified based on this plan's start date. Do you want to continue?";
      this._showWarningMessage(message);
    } else {
      this._savePlan();
    }
  }

  _showWarningMessage(message: string) {
    bootbox.confirm({
      closeButton: false,
      title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
      message,
      className: 'zIndex1060',
      buttons: {
        confirm: {
          label: 'Yes',
          className: 'btn-success'
        },
        cancel: {
          label: 'Cancel',
          className: 'btn-danger'
        }
      },
      callback: (result: boolean) => {
        if (result) {
          this._savePlan();
        }
      }
    });
  }

  _savePlan() {
    this.planService.savePlan(this.selectedPlan, (data: any) => {
      this.selectedPlan = data;
      const successMessage = this.isModifyPlan ? 'Company Plan modified successfully' : 'Company Plan chosen successfully';
      this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
      this.callbackObject.callbackType = 'save';
      this.callbackObject.entity = this.selectedPlan;
      this.onClose.next(this.callbackObject);
      this.bsModalRef.hide();
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }
}
